module.exports = __webpack_public_path__ + "75add7c5fecbec18504f47f530a47d73.svg";